<!--suppress UnterminatedStatementJS -->
<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-container fluid>
        <v-data-table
                :headers="headers"
                :items="referrals"
                class="elevation-1"
        >
            <template v-slot:top>
                <v-toolbar flat color="white">
                    <v-toolbar-title><span class="subtitle-1">Всего приглашенных: {{referrals.length}}</span></v-toolbar-title>
                </v-toolbar>
            </template>
            <template v-slot:item.created_at="{ item }">
                {{getDate(item.created_at)}}
            </template>
        </v-data-table>
    </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: 'VariablesClient',
    props: ['clientId', 'clientModel', 'selectedMenu'],
    computed: {
        ...mapGetters({
            clients: 'clients/clients',
            getVariablesClientByUserId: 'clients/getClientByUserId'
        })
    },
    data() {
        return {
            dialog: false,
            variablesClient: {
                user_id: null,
                variablesClient: []
            },
            headers: [
                {
                    text: 'id',
                    align: 'left',
                    sortable: true,
                    value: 'id'
                },
                { text: 'Ник', value: 'username' },
                { text: 'Имя', value: 'first_name' },
                { text: 'Фамилия', value: 'last_name' },
                { text: 'Зарегистрирован', value: 'created_at' }
            ],
            variableClientModel: {
                id: null,
                value: null
            },
            referrals: []
        }
    },
    methods: {
        saveValue() {
            /* this.clientModel.unsubscribe_time = Date.parse(this.theDate) / 1000
            this.$store.dispatch('scenarios/variableClientUpdate', this.clientModel).then(response => {
                if (response.type === 'VariableClientResult') {
                    this.paramsSnackbar.color = 'success'
                    this.paramsSnackbar.text = 'Успешно сохранено!'
                }
                this.snackbar = true
            }) */
        },
        loadModel() {
            if (this.clientId != null) {
                // this.clientModel = Object.assign({}, this.getVariablesClientByUserId(this.clientId))
                this.$store.dispatch('clients/getInvitedClients', this.clientModel).then(response => {
                    this.referrals = response.response.data
                })
            }
        },
        editItem(item) {
            this.variableClientModel.id = +item.id
            this.variableClientModel.value = item.value
            this.dialog = true
        },
        variablesClientUpdate() {
            this.$store.dispatch('scenarios/variableClientUpdate', this.variableClientModel)
            // this.variableClientModel.id = null
            // this.variableClientModel.value = null
            this.dialog = false
        },
        zero(number) {
            if (number < 10) {
                number = '0' + number
            }
            return number
        },
        getDate(updatedAt) {
            let theDate = new Date(updatedAt * 1000)
            return this.zero(theDate.getHours()) + ':' + this.zero((theDate.getMinutes())) + ' ' + this.zero(theDate.getDate()) + '.' + this.zero((theDate.getMonth() + 1)) + '.' + theDate.getFullYear()
        }
    },
    watch: {
        selectedMenu(value) {
            if (value === 2) { // если в clientForm выбрали меню с переменными
                this.loadModel()
            }
        }
    }
}
</script>

<style scoped>

</style>
